import React from 'react';
import { Box, Container, CssBaseline } from '@mui/material';
import Navigation from './Navigation';
import Footer from './Footer';
import ToastNotification from '../common/ToastNotification';
import ChatBot from '../chatBot/ChatBot';

const Layout = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />
      
      {/* Навигация - най-горе */}
      <Navigation />
      
      {/* Основно съдържание */}
      <Box component="main" sx={{ flexGrow: 1, py: 3 }}>
        <Container maxWidth="xl">
          {children}
        </Container>
      </Box>
      
      {/* Футър - най-долу */}
      <Footer />
      
      {/* Глобални компоненти */}
      <ToastNotification />
      {/* <ChatBot /> */}
    </Box>
  );
};

export default Layout;